import { render, staticRenderFns } from "./personnelPassageRecord.vue?vue&type=template&id=c3f2ec38&scoped=true&"
import script from "./personnelPassageRecord.vue?vue&type=script&lang=js&"
export * from "./personnelPassageRecord.vue?vue&type=script&lang=js&"
import style0 from "./personnelPassageRecord.vue?vue&type=style&index=0&id=c3f2ec38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f2ec38",
  null
  
)

export default component.exports